module.exports = __webpack_public_path__ + "img/tron (47).92fb5ea5.jpg";